import { api } from "../utilites/api";

export const RoleApi = {
  getCompanyRoles: (companyId: number) => api.get(`company/${companyId}/roles`),
  getCSRoles: () => api.get(`roles/csroles`, '2.0'),
}